const Facility = () => {
  return (
    <div>
      <h1>FACILITY</h1>
    </div>
  );
};

export default Facility;
